import { NgModule } from '@angular/core';
import {CommonModule, DecimalPipe} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatIconModule} from '@angular/material/icon';
import {AngularFireModule} from '@angular/fire';
import {AngularFireAuthGuardModule} from '@angular/fire/auth-guard';
import {MatListModule} from '@angular/material/list';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {environment} from '../../environments/environment';
import {AngularFireAuthModule} from '@angular/fire/auth';
import {AngularFirestoreModule} from '@angular/fire/firestore';
import {FlexLayoutModule} from '@angular/flex-layout';
import {ErrorMessageComponent} from './dialog/error-message/error-message.component';
import {InfoMessageComponent} from './dialog/info-message/info-message.component';
import {MatButtonModule} from '@angular/material/button';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatCardModule} from '@angular/material/card';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule} from '@angular/material/core';
import {NgSelectModule} from '@ng-select/ng-select';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {MatDialogModule} from '@angular/material/dialog';
import {MatExpansionModule} from '@angular/material/expansion';
import {AnkenSubDialogComponent} from './dialog/anken-sub-dialog/anken-sub-dialog.component';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {TimestampPipe} from '../core/pipe/timestamp.pipe';
import {SearchPipe} from '../core/pipe/search.pipe';
import {DateAgoPipe} from '../core/pipe/date-ago.pipe';
import {MatTableModule} from '@angular/material/table';
import { LayoutComponent } from './layout/layout.component';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {StringDateAdapter} from './string-date-adapter/string-date-adapter';
import {MAT_2DIGIT_DATE_FORMATS} from './string-date-adapter/date-format';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {LoadingComponent} from './loading/loading.component';
import {ListFilterPipe} from '../core/pipe/list-filter.pipe';
import {DateFilterPipe} from '../core/pipe/date-filter.pipe';
import {IsDeletedFilterPipe} from '../core/pipe/is-deleted-filter.pipe';
import {ListArrayFilterPipe} from '../core/pipe/list-array-filter.pipe';
import {EventGroupArrayPipe} from '../core/pipe/event-group-array.pipe';
import { NyuukaEventDialogComponent } from './dialog/nyuuka-event-dialog/nyuuka-event-dialog.component';
import { ShukkaEventDialogComponent } from './dialog/shukka-event-dialog/shukka-event-dialog.component';
import { VaccineEventDialogComponent } from './dialog/vaccine-event-dialog/vaccine-event-dialog.component';
import { SaizaiEventDialogComponent } from './dialog/saizai-event-dialog/saizai-event-dialog.component';
import { SaiketsuEventDialogComponent } from './dialog/saiketsu-event-dialog/saiketsu-event-dialog.component';
import { TaisokuEventDialogComponent } from './dialog/taisoku-event-dialog/taisoku-event-dialog.component';
import {EventEditComponent} from '../event/event-edit/event-edit.component';
import { OtherEventDialogComponent } from './dialog/other-event-dialog/other-event-dialog.component';
import {EventIchiranComponent} from '../event/event-ichiran/event-ichiran.component';
import { FeedMasterDialogComponent } from './dialog/feed-master-dialog/feed-master-dialog.component';
import { AlertMasterDialogComponent } from './dialog/alert-master-dialog/alert-master-dialog.component';
import {GroupByPipe} from '../core/pipe/group-by.pipe';
import {HttpClientModule} from '@angular/common/http';
import { AlertEditDialogComponent } from './dialog/alert-edit-dialog/alert-edit-dialog.component';
import { AngularSplitModule } from 'angular-split';
import { KeishaHibetsuInfoComponent } from './components/keisha-hibetsu-info/keisha-hibetsu-info.component';
import { SetLayoutDialogComponent } from './dialog/set-layout-dialog/set-layout-dialog.component';
import {MatGridListModule} from '@angular/material/grid-list';
import { TentouMasterDialogComponent } from './dialog/tentou-master-dialog/tentou-master-dialog.component';
import { IkuseiKirokuSubDialogComponent } from './dialog/ikusei-kiroku-sub-dialog/ikusei-kiroku-sub-dialog.component';
import {MatTooltipModule} from '@angular/material/tooltip';
import { ColorPickerModule } from 'ngx-color-picker';
import { DebeakEventDialogComponent } from './dialog/debeak-event-dialog/debeak-event-dialog.component';
import {MatTabsModule} from '@angular/material/tabs';
import { EsaTentouRegisterDialogComponent } from './dialog/esa-tentou-register-dialog/esa-tentou-register-dialog.component';
import {KeishaMeisaiComponent} from '../keisha-meisai/keisha-meisai.component';
import { KeishaSubDialogComponent } from './dialog/keisha-sub-dialog/keisha-sub-dialog.component';
import { PercentBarComponent } from './components/percent-bar/percent-bar.component';
import {MatBadgeModule} from '@angular/material/badge';
import {MatMenuModule} from '@angular/material/menu';
import {DummyDirective} from '../core/directive/dummy.directive';
import {SearchListFilterPipe} from '../core/pipe/search-list-filter.pipe';
import { AddShukkasakiDialogComponent } from './dialog/add-shukkasaki-dialog/add-shukkasaki-dialog.component';
import { AddKeishuDialogComponent } from './dialog/add-keishu-dialog/add-keishu-dialog.component';
import { TemplateRefComponent } from './components/template-ref/template-ref.component';
import {MatTreeModule} from '@angular/material/tree';
import { SelectShiyoulotDialogComponent } from './dialog/select-shiyoulot-dialog/select-shiyoulot-dialog.component';
import {MatRadioModule} from '@angular/material/radio';
import {KeyValueOrderPipe} from '../core/pipe/key-value-order.pipe';
import {MaxRangeDirective} from '../core/directive/max-range-directive.directive';
import {IntegerOnlyDirective} from '../core/directive/integer-only.directive';
import {AbsPipe} from '../core/pipe/abs.pipe';
import { MokuhyouTemperatureMasterDialogComponent } from './dialog/mokuhyou-temperature-master-dialog/mokuhyou-temperature-master-dialog.component';
import { AddChumonDialogComponent } from './dialog/add-chumon-dialog/add-chumon-dialog.component';
import { SagyouKirokuCsvExportDialogComponent } from './dialog/sagyou-kiroku-csv-export-dialog/sagyou-kiroku-csv-export-dialog.component';
import {FormControlPipe} from '../core/pipe/form-control.pipe';
import {TranslateModule} from '@ngx-translate/core';

@NgModule({
  declarations: [
    InfoMessageComponent,
    ErrorMessageComponent,
    AnkenSubDialogComponent,
    DateAgoPipe, SearchPipe,
    TimestampPipe, ListFilterPipe,
    DateFilterPipe, IsDeletedFilterPipe,
    ListArrayFilterPipe, EventGroupArrayPipe, AbsPipe,
    GroupByPipe, SearchListFilterPipe, KeyValueOrderPipe,
    FormControlPipe,
    DummyDirective,
    MaxRangeDirective,
    IntegerOnlyDirective,
    LayoutComponent,
    LoadingComponent,
    NyuukaEventDialogComponent,
    ShukkaEventDialogComponent,
    VaccineEventDialogComponent,
    SaizaiEventDialogComponent,
    SaiketsuEventDialogComponent,
    TaisokuEventDialogComponent,
    EventEditComponent,
    OtherEventDialogComponent,
    EventIchiranComponent,
    FeedMasterDialogComponent,
    AlertMasterDialogComponent,
    AlertEditDialogComponent,
    KeishaHibetsuInfoComponent,
    SetLayoutDialogComponent,
    TentouMasterDialogComponent,
    IkuseiKirokuSubDialogComponent,
    DebeakEventDialogComponent,
    EsaTentouRegisterDialogComponent,
    KeishaMeisaiComponent,
    KeishaSubDialogComponent,
    PercentBarComponent,
    AddShukkasakiDialogComponent,
    AddKeishuDialogComponent,
    TemplateRefComponent,
    SelectShiyoulotDialogComponent,
    MokuhyouTemperatureMasterDialogComponent,
    AddChumonDialogComponent,
    SagyouKirokuCsvExportDialogComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    HttpClientModule,
    MatToolbarModule,
    MatIconModule,
    MatSidenavModule,
    MatListModule,
    MatSnackBarModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSlideToggleModule,
    MatDialogModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatTableModule,
    MatButtonToggleModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatBadgeModule,
    MatMenuModule,
    MatTreeModule,
    DragDropModule,
    NgSelectModule,
    MatRadioModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireAuthModule,
    AngularFirestoreModule,
    AngularFireAuthGuardModule,
    FlexLayoutModule,
    CommonModule,
    AngularSplitModule.forRoot(),
    MatGridListModule,
    ColorPickerModule,
    MatTabsModule,
    TranslateModule
  ],
  providers: [MatDatepickerModule,
    /* Datepicker の多言語化 */
    {provide: MAT_DATE_LOCALE, useFactory: () => {
      if (typeof navigator.languages !== 'undefined' && navigator.languages.length > 0) {
        return navigator.languages[0];
      }
      if (navigator.language) {
        return navigator.language;
      }
      return 'en';
    }},
    {provide: DateAdapter, useClass: StringDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MAT_2DIGIT_DATE_FORMATS},
    TimestampPipe, DecimalPipe
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatToolbarModule,
    MatIconModule,
    MatSidenavModule,
    MatListModule,
    MatSnackBarModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule,
    MatRadioModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSlideToggleModule,
    MatDialogModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatTableModule,
    MatButtonToggleModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatBadgeModule,
    MatMenuModule,
    MatTreeModule,
    DragDropModule,
    NgSelectModule,
    AngularFireAuthModule,
    AngularFireAuthGuardModule,
    AngularFirestoreModule,
    FlexLayoutModule,
    DateAgoPipe, SearchPipe,
    TimestampPipe, ListFilterPipe,
    DateFilterPipe, IsDeletedFilterPipe,
    ListArrayFilterPipe, EventGroupArrayPipe, AbsPipe,
    GroupByPipe, SearchListFilterPipe, KeyValueOrderPipe,
    DummyDirective,
    MaxRangeDirective,
    IntegerOnlyDirective,
    LoadingComponent,
    EventIchiranComponent,
    AngularSplitModule, KeishaHibetsuInfoComponent,
    MatGridListModule,
    ColorPickerModule,
    MatTabsModule,
    KeishaMeisaiComponent,
    PercentBarComponent, TemplateRefComponent,
    TranslateModule
  ]
})
export class SharedModule { }
